import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withKeys as _withKeys, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e356b7d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "orderHistory" }
const _hoisted_2 = { class: "display-2 center mb-4" }
const _hoisted_3 = { class: "clubOrdersContainer" }
const _hoisted_4 = { class: "layout gutter--lg" }
const _hoisted_5 = { class: "row justify--center align--center" }
const _hoisted_6 = { class: "md2 flex mobile" }
const _hoisted_7 = {
  class: "md6 flex",
  style: {"display":"flex"}
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Søg")
const _hoisted_9 = { class: "va-table-responsive" }
const _hoisted_10 = {
  class: "va-table va-table--striped invoiceTable",
  style: {"width":"100%"}
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Faktura", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Bill", -1))
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "ordersTable center" }
const _hoisted_15 = { class: "ordersTable center" }
const _hoisted_16 = { class: "ordersTable center" }
const _hoisted_17 = {
  key: 0,
  class: "ordersTable"
}
const _hoisted_18 = ["href"]
const _hoisted_19 = {
  key: 1,
  class: "ordersTable"
}
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Download (PDF)")
const _hoisted_21 = {
  key: 2,
  class: "ordersTable"
}
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Bill")
const _hoisted_23 = {
  key: 3,
  class: "ordersTable"
}
const _hoisted_24 = { class: "row justify--center align--baseline paginationControls mb-2" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mr-2" }, "Side:", -1))
const _hoisted_26 = {
  key: 0,
  class: "mr-2"
}
const _hoisted_27 = {
  key: 1,
  class: "mr-2"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mr-2" }, "Antal rækker per side:", -1))
const _hoisted_29 = { class: "selectPageSize" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "display-4 center" }, "Ordreinformation", -1))
const _hoisted_31 = { class: "editOrderModal layout gutter--xl" }
const _hoisted_32 = { class: "center mb-4 emphasiseText" }
const _hoisted_33 = { class: "row justify--space-around align--center" }
const _hoisted_34 = { class: "flex" }
const _hoisted_35 = { class: "flex" }
const _hoisted_36 = { class: "flex" }
const _hoisted_37 = { class: "row justify--center align--center" }
const _hoisted_38 = { class: "flex md3" }
const _hoisted_39 = { class: "registeredUserBox" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "registeredUserLabel" }, "Registreret bruger? ", -1))
const _hoisted_41 = { class: "flex md3 xs12" }
const _hoisted_42 = { class: "md3 flex xs12" }
const _hoisted_43 = { class: "md3 flex center xs12" }
const _hoisted_44 = { class: "row justify--center align--center" }
const _hoisted_45 = { class: "md12 flex xs12" }
const _hoisted_46 = { class: "row justify--center align--center" }
const _hoisted_47 = { class: "flex md8 xs12" }
const _hoisted_48 = { class: "flex md4 xs12" }
const _hoisted_49 = { class: "row jstufiy--center align--center" }
const _hoisted_50 = { class: "flex md3 xs12" }
const _hoisted_51 = { class: "flex md2 xs6" }
const _hoisted_52 = { class: "flex md3 xs6" }
const _hoisted_53 = { class: "flex md4 xs12" }
const _hoisted_54 = { class: "row justify--center align--center" }
const _hoisted_55 = { class: "flex md5 xs12" }
const _hoisted_56 = { class: "flex md7 xs12" }
const _hoisted_57 = {
  key: 0,
  class: "orderUnitBox"
}
const _hoisted_58 = { class: "va-table-responsive" }
const _hoisted_59 = {
  class: "va-table va-table--hoverable",
  style: {"width":"100%"}
}
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Produkter"),
    /*#__PURE__*/_createElementVNode("th", null, "Antal"),
    /*#__PURE__*/_createElementVNode("th", null, "Stk. Pris")
  ])
], -1))
const _hoisted_61 = { class: "center" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "orderTotal" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Total:")
], -1))
const _hoisted_64 = { class: "row justify--center" }
const _hoisted_65 = { class: "flex" }
const _hoisted_66 = /*#__PURE__*/_createTextVNode("Luk")
const _hoisted_67 = { class: "pdf-body" }
const _hoisted_68 = { class: "invoice" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "invoice-title" }, "Kvittering", -1))
const _hoisted_70 = { class: "invoice-header flex" }
const _hoisted_71 = { class: "order" }
const _hoisted_72 = { class: "info" }
const _hoisted_73 = { class: "date" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "club" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo",
    src: "https://api.dart-ddu.dk/uploads/DD_Ulogo_a9e588e055.png",
    alt: "Dansk Dart Union Logo",
    width: "55",
    height: "75"
  }),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h6", null, "Dansk Dart Union"),
    /*#__PURE__*/_createElementVNode("p", null, "Idrættens Hus"),
    /*#__PURE__*/_createElementVNode("p", null, "Brøndby Stadion 20"),
    /*#__PURE__*/_createElementVNode("p", null, "2605 Brøndby")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("p", null, "Tlf. 62 65 61 20"),
    /*#__PURE__*/_createElementVNode("p", null, "info@dart-ddu.dk")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("p", null, "Kontonr. 7703-0001106339"),
    /*#__PURE__*/_createElementVNode("p", null, "CVR 90406450")
  ])
], -1))
const _hoisted_75 = { class: "products" }
const _hoisted_76 = { class: "products-title" }
const _hoisted_77 = { class: "products-grid" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header product-order" }, [
  /*#__PURE__*/_createElementVNode("h6", null, "Bestilling")
], -1))
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header product-units" }, [
  /*#__PURE__*/_createElementVNode("h6", null, "Antal")
], -1))
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header product-price" }, [
  /*#__PURE__*/_createElementVNode("h6", null, "Pris")
], -1))
const _hoisted_81 = { class: "product product-order" }
const _hoisted_82 = { class: "product product-units" }
const _hoisted_83 = { class: "product product-price" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer product-total" }, [
  /*#__PURE__*/_createElementVNode("h6", null, "I ALT")
], -1))
const _hoisted_85 = { class: "footer product product-price" }
const _hoisted_86 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_popover = _resolveComponent("va-popover")!
  const _component_va_input = _resolveComponent("va-input")!
  const _component_it_divider = _resolveComponent("it-divider")!
  const _component_va_select = _resolveComponent("va-select")!
  const _component_it_modal = _resolveComponent("it-modal")!
  const _component_vue3_html2pdf = _resolveComponent("vue3-html2pdf")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h2", _hoisted_2, "Ordrehistorik for " + _toDisplayString(_ctx.clubName), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_va_popover, {
                color: "primary",
                message: "Nulstil kolonner"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_va_button, {
                    class: "btn",
                    rounded: false,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.columnSort('reset')))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_va_icon, {
                        class: "reset",
                        name: "autorenew"
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_va_input, {
                modelValue: _ctx.orderSearchInputValue,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.orderSearchInputValue) = $event)),
                label: "Søg",
                onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.findOrder()), ["enter"]))
              }, {
                prependInner: _withCtx(() => [
                  _createVNode(_component_va_icon, { name: "person_search" })
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_va_button, {
                size: "small",
                class: "btn ml-2",
                rounded: false,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.findOrder()))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_va_icon, { name: "search" }),
                  _hoisted_8
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _createVNode(_component_it_divider),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("table", _hoisted_10, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  class: "sorting center",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.columnSort('invoiceId')))
                }, "Faktura nr"),
                _createElementVNode("th", {
                  class: "center sorting",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.columnSort('date')))
                }, "Dato"),
                _createElementVNode("th", {
                  class: "sorting center",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.columnSort('status')))
                }, "Ordrestatus"),
                _createElementVNode("th", {
                  class: "sorting center",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.columnSort('total')))
                }, "Samlet pris"),
                _hoisted_11,
                _hoisted_12
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.memberOrderHistory, (memberOrder, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", {
                    class: "center ordersTable clickAble",
                    onClick: ($event: any) => (_ctx.orderInfo(memberOrder.id))
                  }, _toDisplayString(memberOrder.ordre_fakturanummer), 9, _hoisted_13),
                  _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.danishDateFormat(memberOrder.created_at)), 1),
                  _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.parseEnum(memberOrder.ordre_status)), 1),
                  _createElementVNode("td", _hoisted_16, _toDisplayString(memberOrder.ordre_total + ' kr.'), 1),
                  (memberOrder.ordre_faktura.length > 0)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_17, [
                        _createElementVNode("a", {
                          target: "_blank",
                          href: _ctx.generateInvoiceURL(memberOrder.ordre_faktura[0].url)
                        }, _toDisplayString(memberOrder.ordre_faktura[0].name), 9, _hoisted_18)
                      ]))
                    : (_openBlock(), _createElementBlock("td", _hoisted_19, [
                        _createVNode(_component_va_button, {
                          color: "info",
                          onClick: ($event: any) => (_ctx.downloadPdf(memberOrder.id))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_20
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ])),
                  ((memberOrder.event_status === 'afbud' || memberOrder.event_status === 'udeblivelse') && (memberOrder.ordre_status === 'afventer' || memberOrder.ordre_status === 'annulleret'))
                    ? (_openBlock(), _createElementBlock("td", _hoisted_21, [
                        _createVNode(_component_va_button, {
                          color: "info",
                          onClick: ($event: any) => (_ctx.onBillButton(memberOrder?.kamp_nummer, memberOrder.event_status))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_22
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]))
                    : (_openBlock(), _createElementBlock("td", _hoisted_23))
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createVNode(_component_va_button, {
            icon: "first_page",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.jumpToOrderPage(1)))
          }),
          _createVNode(_component_va_button, {
            icon: "keyboard_double_arrow_left",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.turnToNewOrderPage(-5)))
          }),
          _createVNode(_component_va_button, {
            icon: "chevron_left",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.turnToNewOrderPage(-1)))
          }),
          _hoisted_25,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.currentOrderPage) = $event)),
            type: "number",
            onKeyup: _cache[12] || (_cache[12] = _withKeys(($event: any) => (_ctx.jumpToProductPage(this.currentProductPage)), ["enter"]))
          }, null, 544), [
            [_vModelText, _ctx.currentOrderPage]
          ]),
          (_ctx.totalNumberOfOrderPages === 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_26, " af " + _toDisplayString(_ctx.totalNumberOfOrderPages+1), 1))
            : (_openBlock(), _createElementBlock("p", _hoisted_27, " af " + _toDisplayString(_ctx.totalNumberOfOrderPages), 1)),
          _createVNode(_component_va_button, {
            icon: "chevron_right",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.turnToNewOrderPage(1)))
          }),
          _createVNode(_component_va_button, {
            icon: "keyboard_double_arrow_right",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.turnToNewOrderPage(5)))
          }),
          _createVNode(_component_va_button, {
            icon: "last_page",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.jumpToOrderPage(this.totalNumberOfProductPages)))
          }),
          _hoisted_28,
          _createElementVNode("div", _hoisted_29, [
            _createVNode(_component_va_select, {
              class: "mr-2",
              modelValue: _ctx.orderPageSizeValueString,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.orderPageSizeValueString) = $event)),
              options: _ctx.orderPageSizeOptions,
              bordered: ""
            }, null, 8, ["modelValue", "options"])
          ])
        ])
      ]),
      _createVNode(_component_it_modal, {
        modelValue: _ctx.orderInfoModal,
        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.orderInfoModal) = $event)),
        width: _ctx.screenSize > 1000 ? '50%' : '100%'
      }, {
        header: _withCtx(() => [
          _hoisted_30
        ]),
        body: _withCtx(() => [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("p", _hoisted_32, "Ordre nr. " + _toDisplayString(_ctx.orderData.orderInvoiceNumber), 1),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("p", null, [
                  _createElementVNode("i", null, "Oprettet: " + _toDisplayString(_ctx.orderData.orderCreated), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("p", null, [
                  _createElementVNode("i", null, "Sidst opdateret: " + _toDisplayString(_ctx.orderData.orderUpdated), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("p", null, [
                  _createElementVNode("i", null, "Transaktionnummer: " + _toDisplayString(_ctx.orderData.orderTransaction), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _hoisted_40,
                  _createVNode(_component_va_icon, {
                    name: _ctx.orderData.userName !== '' ? 'check_box' : 'check_box_outline_blank',
                    color: _ctx.orderData.userName !== '' ? 'success' : 'rgb(255, 172, 10)'
                  }, null, 8, ["name", "color"])
                ])
              ]),
              _createElementVNode("div", _hoisted_41, [
                (_ctx.orderData.userName !== '')
                  ? (_openBlock(), _createBlock(_component_va_input, {
                      key: 0,
                      readonly: "",
                      label: "Brugernavn",
                      modelValue: _ctx.orderData.userName,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.orderData.userName) = $event)),
                      bordered: "",
                      type: "text"
                    }, null, 8, ["modelValue"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_42, [
                _createVNode(_component_va_input, {
                  modelValue: _ctx.orderData.orderStatus,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.orderData.orderStatus) = $event)),
                  label: "Ordrestatus",
                  bordered: "",
                  readonly: ""
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_43, [
                _createVNode(_component_va_input, {
                  readonly: "",
                  modelValue: _ctx.orderData.orderInvoiceNumber,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.orderData.orderInvoiceNumber) = $event)),
                  type: "number",
                  label: "Fakturanummer",
                  bordered: ""
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                _createVNode(_component_va_input, {
                  readonly: "",
                  modelValue: _ctx.orderData.orderName,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.orderData.orderName) = $event)),
                  type: "text",
                  label: "Navn",
                  bordered: ""
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _createVNode(_component_va_input, {
                  modelValue: _ctx.orderData.orderAddress,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.orderData.orderAddress) = $event)),
                  readonly: "",
                  type: "text",
                  label: "Adresse",
                  bordered: ""
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_48, [
                _createVNode(_component_va_input, {
                  modelValue: _ctx.orderData.orderTelephone,
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.orderData.orderTelephone) = $event)),
                  readonly: "",
                  type: "text",
                  label: "Telefon",
                  bordered: ""
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("div", _hoisted_50, [
                _createVNode(_component_va_input, {
                  modelValue: _ctx.orderData.orderCountry,
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.orderData.orderCountry) = $event)),
                  readonly: "",
                  type: "text",
                  label: "Land",
                  bordered: ""
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_51, [
                _createVNode(_component_va_input, {
                  modelValue: _ctx.orderData.orderPostalNumber,
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.orderData.orderPostalNumber) = $event)),
                  readonly: "",
                  type: "text",
                  label: "Postnr.",
                  bordered: ""
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_52, [
                _createVNode(_component_va_input, {
                  modelValue: _ctx.orderData.orderCity,
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.orderData.orderCity) = $event)),
                  readonly: "",
                  type: "text",
                  label: "By",
                  bordered: ""
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_53, [
                _createVNode(_component_va_input, {
                  modelValue: _ctx.orderData.orderEmail,
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.orderData.orderEmail) = $event)),
                  readonly: "",
                  type: "text",
                  label: "Email",
                  bordered: ""
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("div", _hoisted_55, [
                _createVNode(_component_va_input, {
                  modelValue: _ctx.orderData.orderComment,
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.orderData.orderComment) = $event)),
                  readonly: "",
                  type: "textarea",
                  class: "commentBox",
                  label: "Kommentarer",
                  bordered: ""
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_56, [
                (_ctx.orderData.orderUnits !== null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                      _createElementVNode("div", _hoisted_58, [
                        _createElementVNode("table", _hoisted_59, [
                          _hoisted_60,
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderData.orderUnits, (unit) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: unit.id
                              }, [
                                _createElementVNode("td", null, _toDisplayString(unit.ordreenheder_beskrivelse), 1),
                                _createElementVNode("td", _hoisted_61, _toDisplayString(unit.ordreenheder_antal), 1),
                                _createElementVNode("td", null, _toDisplayString(_ctx.findUnitPrice(unit.produkt_id)) + " kr.", 1)
                              ]))
                            }), 128)),
                            _createElementVNode("tr", null, [
                              _hoisted_62,
                              _hoisted_63,
                              _createElementVNode("td", null, [
                                _createElementVNode("strong", null, _toDisplayString(_ctx.orderData.orderTotal) + " kr.", 1)
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        actions: _withCtx(() => [
          _createElementVNode("div", _hoisted_64, [
            _createElementVNode("div", _hoisted_65, [
              _createVNode(_component_va_button, {
                color: "secondary",
                onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.orderInfoModal = false))
              }, {
                default: _withCtx(() => [
                  _hoisted_66
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "width"])
    ]),
    _createVNode(_component_vue3_html2pdf, {
      "show-layout": false,
      "float-layout": true,
      "preview-modal": true,
      "enable-download": false,
      "paginate-elements-by-height": 1400,
      filename: _ctx.seriesString + ', ' + _ctx.seasonString,
      "pdf-quality": 2,
      "manual-pagination": false,
      "pdf-format": "a4",
      "pdf-orientation": "portrait",
      "pdf-content-width": "100%",
      ref: "html2Pdf"
    }, {
      "pdf-content": _withCtx(() => [
        _createElementVNode("div", _hoisted_67, [
          _createElementVNode("div", _hoisted_68, [
            _hoisted_69,
            _createElementVNode("div", _hoisted_70, [
              _createElementVNode("div", _hoisted_71, [
                _createElementVNode("div", _hoisted_72, [
                  _createElementVNode("h6", null, _toDisplayString(_ctx.orderData.orderName), 1),
                  _createElementVNode("p", null, _toDisplayString(_ctx.orderData.orderAddress), 1),
                  _createElementVNode("p", null, _toDisplayString(_ctx.orderData.orderPostalNumber + ' ' + _ctx.orderData.orderCity), 1),
                  _createElementVNode("p", null, _toDisplayString(_ctx.orderData.orderEmail), 1)
                ]),
                _createElementVNode("p", _hoisted_73, _toDisplayString('d. ' + _ctx.orderData.orderCreated), 1)
              ]),
              _hoisted_74
            ]),
            _createElementVNode("div", _hoisted_75, [
              _createElementVNode("div", _hoisted_76, [
                _createElementVNode("p", null, "Fakturanummer " + _toDisplayString(_ctx.orderData.orderInvoiceNumber), 1)
              ]),
              _createElementVNode("div", _hoisted_77, [
                _hoisted_78,
                _hoisted_79,
                _hoisted_80,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderData.orderUnits, (product) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: product.id
                  }, [
                    _createElementVNode("div", _hoisted_81, _toDisplayString(product.ordreenheder_beskrivelse), 1),
                    _createElementVNode("div", _hoisted_82, _toDisplayString(product.ordreenheder_antal), 1),
                    _createElementVNode("div", _hoisted_83, _toDisplayString(product.ordreenheder_pris + ' DKK'), 1)
                  ], 64))
                }), 128)),
                _hoisted_84,
                _createElementVNode("div", _hoisted_85, [
                  _createElementVNode("h6", null, _toDisplayString(_ctx.orderData.orderTotal + ' DKK'), 1)
                ])
              ])
            ]),
            false
              ? (_openBlock(), _createElementBlock("div", _hoisted_86, _toDisplayString(_ctx.orderData), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["filename"])
  ]))
}